import { render } from "./bookDetail.vue?vue&type=template&id=0933a9b4&scoped=true"
import script from "./bookDetail.vue?vue&type=script&lang=js"
export * from "./bookDetail.vue?vue&type=script&lang=js"

import "./bookDetail.vue?vue&type=style&index=0&id=0933a9b4&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0933a9b4"]])

export default __exports__